import { required, validEmail } from 'services/validators'
import { isValidPhoneNumber } from 'react-phone-number-input'


const reportPropertyValidator = values => {
  let errors = {}
  if (!required(values.reason)) {
    errors.reason = 'Razón requerida'
  }
  if (!required(values.fullName)) {
    errors.fullName = 'Nombre completo requerido'
  }
  if (!required(values.email)) {
    errors.email = 'Email requerido'
  } else if (!validEmail(values.email)) {
    errors.email = 'Email inválido'
  } 
  if (!required(values.telephone)) {
    errors.telephone = 'Teléfono requerido'
  } else if (!isValidPhoneNumber(values.telephone)) {
    errors.telephone = 'Teléfono inválido'
  } 
  if (required(values.telephone)) {
    errors.email = ''
  }
  if (required(values.email)) {
    errors.telephone = ''
  }

  return errors
}

export default reportPropertyValidator
